import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MemberLayout.css';

const MemberLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="member-layout">
      <button
        type="button"
        className="mobile-menu-toggle"
        onClick={() => setMenuOpen((open) => !open)}
        aria-label={menuOpen ? '關閉選單' : '開啟選單'}
        aria-expanded={menuOpen}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      <div className={`member-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>會員專區</h2>
          <p>{user?.profile?.chinese_name || user?.phone_number}</p>
          <button type="button" className="member-sidebar-close" onClick={closeMenu} aria-label="關閉選單">
            ✕
          </button>
        </div>
        <nav className="sidebar-nav">
          <Link to="/member" onClick={closeMenu}>儀表板</Link>
          <Link to="/member/profile" onClick={closeMenu}>個人資料</Link>
          <Link to="/member/qr-code" onClick={closeMenu}>我的QR碼</Link>
          <Link to="/member/change-password" onClick={closeMenu}>修改密碼</Link>
          <Link to="/" onClick={closeMenu}>返回首頁</Link>
          <button onClick={handleLogout} className="btn btn-secondary">登出</button>
        </nav>
      </div>
      {menuOpen && <div className="sidebar-overlay" onClick={closeMenu}></div>}
      <div className="member-content">
        <Outlet />
      </div>
    </div>
  );
};

export default MemberLayout;
